import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  AddSchedulingCommentApi,
  getManagerNewRequestListApi,
  getManagerViewRequestApi,
  AddSchedulingEstimateApi,
  getSchedulingBandWidthApi,
  getSchedulingCommentListApi,
  getSchedulingUserViewListApi,
  getSchedulingReEstimateListApi,
  UpdateSchedulingEstimateApi,
  getSchedulingCalendarApi,
  getAllUsersSchedulingListApi,
  getAllClientSchedulingListApi,
  getClientUserSchedulingListApi,
  getClientJobSchedulingListApi,
  getScheduledJobsHourApi,
  getScheduledAllUserMappedToJobApi,
  getUserAvailabilityReportApi,
  revokeSchedulingRequestApi,
} from "@/apis/schedulingApis";

import type {
  GetAllClientSchedulingListPayloadType,
  GetClientJobSchedulingListPayloadType,
  GetClientUserSchedulingListPayloadType,
  GetRequestIdPayloadType,
  GetScheduledAllUserMappedToJobPayloadType,
  GetScheduledJobsHourPayloadType,
  GetSchedulingUserPayloadType,
  GetUserAvailabilityReportPayloadType,
  RevokeSchedulingEstimatePayloadType,
} from "@/commonTypes/schedulingTypes";
import type { GetAllUsersSchedulingListPayloadType } from "@/commonTypes/schedulingTypes";

export const getSchedulingUserViewListAction = createAsyncThunk(
  "get/SchedulingUserView",
  async (data: any) => {
    const response = await getSchedulingUserViewListApi(data);
    return response.data;
  }
);
export const getSchedulingEmployeeApprovedListAction = createAsyncThunk(
  "get/SchedulingEmployeeAprrovedView",
  async (data: GetSchedulingUserPayloadType) => {
    const response = await getSchedulingUserViewListApi(data);
    return response.data;
  }
);
export const getSchedulingCommentListAction = createAsyncThunk(
  "get/SchedulingCommentList",
  async (data: any) => {
    const response = await getSchedulingCommentListApi(data);
    return response.data;
  }
);

export const AddSchedulingCommentAction = createAsyncThunk(
  "add/SchedulingComment",
  async (data: any) => {
    const response = await AddSchedulingCommentApi(data);
    return response.data;
  }
);
export const getSchedulingBandWidthAction = createAsyncThunk(
  "get/SchedulingRequestLinkView",
  async (data: any) => {
    const response = await getSchedulingBandWidthApi(data);
    return response.data;
  }
);

export const getManagerNewRequestList = createAsyncThunk(
  'get/ManagerNewRequestList"',

  async (data: any) => {
    const response = await getManagerNewRequestListApi(data);
    return response.data;
  }
);

export const AddSchedulingEstimateAction = createAsyncThunk(
  "get/SchedulingAddEstimate",
  async (data: any) => {
    const response = await AddSchedulingEstimateApi(data);
    return response.data;
  }
);

export const getViewRequestAction = createAsyncThunk(
  "get/viewRequestAction",
  async (data: any) => {
    const response = await getManagerViewRequestApi(data);
    return response.data;
  }
);

export const getSchedulingReEstimateListAction = createAsyncThunk(
  "get/SchedulingReEstimateAction",
  async (data: GetRequestIdPayloadType) => {
    const response = await getSchedulingReEstimateListApi(data);
    return response.data;
  }
);
export const updateRequestAction = createAsyncThunk(
  "update/request",
  async (data: any) => {
    const response = await UpdateSchedulingEstimateApi(data);
    return response.data;
  }
);
export const getSchedulingCalendar = createAsyncThunk(
  "get/SchedulingCalendar",
  async (data: any) => {
    const response = await getSchedulingCalendarApi(data);
    return response.data;
  }
);

export const getAllUsersSchedulingListAction = createAsyncThunk(
  "get/AllUsersSchedulingList",
  async (data: GetAllUsersSchedulingListPayloadType) => {
    const response = await getAllUsersSchedulingListApi(data);
    return response.data;
  }
);

export const getAllClientSchedulingListAction = createAsyncThunk(
  "get/AllClientSchedulingList",
  async (data: GetAllClientSchedulingListPayloadType) => {
    const response = await getAllClientSchedulingListApi(data);
    return response.data;
  }
);

export const getClientUserSchedulingListAction = createAsyncThunk(
  "get/ClientUserSchedulingList",
  async (data: GetClientUserSchedulingListPayloadType) => {
    const response = await getClientUserSchedulingListApi(data);
    return response.data;
  }
);

export const getClientJobSchedulingListAction = createAsyncThunk(
  "get/ClientJobSchedulingList",
  async (data: GetClientJobSchedulingListPayloadType) => {
    const response = await getClientJobSchedulingListApi(data);
    return response.data;
  }
);

export const getSingleJobsScheduledListAction = createAsyncThunk(
  "get/ScheduledJobsHourList",
  async (data: GetScheduledJobsHourPayloadType) => {
    const response = await getScheduledJobsHourApi(data);
    return response.data;
  }
);

export const getAllUserMappedToJobAction = createAsyncThunk(
  "get/ScheduledAllClientMappedToJobList",
  async (data: GetScheduledAllUserMappedToJobPayloadType) => {
    const response = await getScheduledAllUserMappedToJobApi(data);
    return response.data;
  }
);

// availability report

export const getUserAvailabilityReportAction = createAsyncThunk(
  "get/UsersAvailabilityReport",
  async (data: GetUserAvailabilityReportPayloadType) => {
    const response = await getUserAvailabilityReportApi(data);
    return response.data;
  }
);

export const revokeSchedulingRequestAction = createAsyncThunk(
  "post/revokeSchedulingRequest",
  async (data: RevokeSchedulingEstimatePayloadType) => {
    const response = await revokeSchedulingRequestApi(data);
    return response.data;
  }
);
